
export default {
  saldo: "R$",
  list: [],
  isUnique: true
}



// WEBPACK FOOTER //
// ./src/features/admin/indicacoes/store/state.js